// extracted by mini-css-extract-plugin
export default {"mainNavLink":"main_nav_link_mainNavLink__M-Wzk","disabled":"main_nav_link_disabled__RkF0X","mainNavLinkActive":"main_nav_link_mainNavLinkActive__5XUmV"};